<template>
    <div>
        <h4>{{ filterName }}</h4>
        <div class="form-check">
            <label class="form-check-label" v-for="option in shortList" v-if="!showMore && hasEnoughOptions()">
                <input class="form-check-input" type="checkbox" :value="option.value" :id="option.value" :name="generateName()" v-model="currentActive" />
                {{ option.label }}
            </label>
            
            <a class="show" v-if="!showMore && hasEnoughOptions()" @click="showMore = true">Show More</a>
            
            <label class="form-check-label" v-for="option in options" v-if="showMore || !hasEnoughOptions()">
                <input class="form-check-input" type="checkbox" :value="option.value" :id="option.value" :name="generateName()" v-model="currentActive" />
                {{ option.label }}
            </label>

            <a class="show" v-if="showMore && hasEnoughOptions()" @click="showMore = false">Show Less</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'filterName': String,
            'options': Array,
            'active': {
                type: Array,
                default: function () { return [] },
            }
        },
        
        data() {
            return {
                currentActive: [],
                showMore: false,
                total: 5,
            }  
        },
        
        created(){
                this.currentActive = this.active;
        },
        
        methods: {
            generateName(){
                return this.filterName + '[]';  
            },

            activeOptions(){
                // we're working off of this.active so unchecked boxes don't disappear from showMore view
                return this.options.filter((option) => this.active.indexOf(option.value) !== -1);
            },

            nonActiveOptions() {
                // we're working off of this.active so unchecked boxes don't disappear from showMore view
                return this.options.filter((option) => this.active.indexOf(option.value) === -1);
            },
            
            hasEnoughOptions() {
                return this.options.length > this.total;
            }
        },
        
        computed: {
            shortList(){
                const active = this.activeOptions();
                const nonActive = this.nonActiveOptions();
                const remaining = this.total - active.length;
                
                if (remaining < 0){
                    return active;
                }
                
                const others = nonActive.slice(0, remaining);
                return active.concat(others); 
            },
        },
    }
</script>

<style>
    .form-check a.show {
        cursor: pointer;
    }

    .form-check a.show:hover {
        text-decoration: underline;
    }
</style>
